import { capitalize, Box, Stack, Typography } from "@mui/material";
import { niceDate, niceTime } from "../../../../utils";
import { Colors } from "../../../../styles/theme";

export const getAppointmentColumns = () => {
    return [
        {
            Header: 'Date',
            accessor: 'startDate',
            Cell: ({ value }) => niceDate(value),
            disableFilters: false,
        },
        {
            Header: 'Time',
            accessor: 'startTime',
            Cell: ({ row }) => niceTime(row.original.startDate),
            disableFilters: true,
        },
        {
            Header: 'Duration',
            accessor: 'duration',
            Cell: ({ value }) => `${value || 'N/A'} min`,
            disableFilters: true,
        },
        {
            Header: 'Practitioner',
            accessor: 'Employee.fullName',
            Cell: ({ value }) => value ? capitalize(value) : 'N/A',
            disableFilters: false,
        },
        {
            Header: 'Location',
            accessor: 'Location.name',
            Cell: ({ value }) => value ? capitalize(value) : 'N/A',
            disableFilters: false,
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ value }) => (
                <Stack flexDirection={'row'} alignItems="center">
                    <Box
                        sx={{
                            width: '10px',
                            height: '10px',
                            background: Colors[value] || Colors.gray,
                            borderRadius: '50%',
                            marginRight: '8px'
                        }}
                    />
                    <Typography variant="caption" sx={{ textTransform: 'uppercase' }}>
                        {value}
                    </Typography>
                </Stack>
            ),
            disableFilters: false,
        },
    ];
};
